module.exports = __webpack_public_path__ + "static/media/KSC.ba1b4981.png";